module.exports = __webpack_public_path__ + "static/media/icon-share.54ea8f51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-share.svg
// module id = 1478
// module chunks = 0